import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

import {
    addCreditCard as addCreditCardAction,
    addPaypal as addPaypalAction
} from '../../actions/paymentMethods';
import { fetchProductsMe } from '../../actions/products';

import AddPaymentMethodForm from '../../../src/components/billing/AddPaymentMethodForm';
import CustomStripeProvider from '../../../src/components/billing/CustomStripeProvider';
import User from '../../models/User';
import PaymentApi from '../../api/Payment';
import PaymentDescription from '../../../src/components/billing/PaymentDescription';
import Loading from '../common/Loading';
import withAnalytics from '../analytics/withAnalytics';

const PaymentMethods = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';

        script.addEventListener('load', () => {
            setIsLoading(true);
        });

        document.body.appendChild(script);
    }, []);

    useEffect(() => {
        props.fetchProductsMe(undefined, true);
    }, []);

    const logoutRedirect = useCallback(() => {
        document.location.href = '/auth/collection-application-under-review';
    }, []);

    const getSubscriptionInfos = () => {
        const { products } = props;
        const subscription = products.find((product) => product.isSubscription());
        if (!subscription) {
            return null;
        }
        const caution = products.find((product) => product.isCaution());
        return {
            type: 'subscription',
            order: 1,
            price: subscription.get('price'),
            deposit: caution ? caution.get('price') : 0,
            isCollection: subscription.get('isCollection')
        };
    };

    const getSending = useCallback((value) => {
        props.getSending(value);
    }, []);

    const { currency, products, user } = props;

    if (!user || !products || products.length === 0 || !currency) {
        return <Loading />;
    }

    const subscriptionInfos = getSubscriptionInfos();

    if (!subscriptionInfos) {
        return null;
    }

    const toggleCollapse = () => {
        setOpen(!open);
    };

    return (
        isLoading && (
            <>
                <h2 className="collection-title">
                    {i18n.t('collection:homeexchange_collection_membership')}
                </h2>
                <div className="container">
                    <div className="container-info">
                        <div className="title-info">{i18n.t('collection:important_note')}</div>
                        <div className="description-info">{i18n.t('collection:to_avoid_fake')}</div>
                    </div>
                </div>
                <div className="container-features">
                    <div className="description-panel panel panel-default">
                        <div className="panel-body">
                            <PaymentDescription
                                currency={currency}
                                products={[subscriptionInfos]}
                                totalToPay={subscriptionInfos.price}
                            />
                        </div>
                    </div>
                    <CustomStripeProvider>
                        <AddPaymentMethodForm
                            context={'my-plan'}
                            user={props.user}
                            addCreditCardAction={props.addCreditCard}
                            addPaypalAction={props.addPaypal}
                            getBraintreeToken={PaymentApi.getBraintreeToken}
                            isFunnelCollection={true}
                            collapseParentPanel={toggleCollapse}
                            logoutRedirect={logoutRedirect}
                            getSending={getSending}
                            track={props.track}
                            paymentMethods={[]}
                        />
                    </CustomStripeProvider>
                </div>
            </>
        )
    );
};

PaymentMethods.propTypes = {
    user: PropTypes.instanceOf(User),
    addCreditCard: PropTypes.func,
    addPaypal: PropTypes.func,
    getSending: PropTypes.func,
    fetchProductsMe: PropTypes.func,
    products: PropTypes.array,
    currency: PropTypes.string,
    track: PropTypes.func
};

const mapStateToProps = (state) => ({
    user: state.user,
    products: state.products,
    currency: state.user ? state.user.get('currency') : null
});

const mapDispatchToProps = (dispatch) => ({
    addCreditCard: bindActionCreators(addCreditCardAction, dispatch),
    addPaypal: bindActionCreators(addPaypalAction, dispatch),
    fetchProductsMe: bindActionCreators(fetchProductsMe, dispatch)
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withAnalytics)(PaymentMethods);
